// extracted by mini-css-extract-plugin
export default {"app":"App_app__Y4DuN","main":"App_main__Rf2PD","text_color_accent":"App_text_color_accent__aOeVC"};